import type { ComponentProps } from 'react';
import { memo } from 'react';

import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/shared/components/ui/tooltip';
import { cn } from '@/shared/utils/cn';

export interface ProfileNameWithAgeProps extends ComponentProps<'p'> {
  name: string;
  age: number | undefined;
}

export const ProfileNameWithAge = memo(function ProfileNameWithAge({
  name,
  age,
  className,
  ...props
}: ProfileNameWithAgeProps) {
  return (
    <p
      className={cn(
        'font-nunito text-cold-100 text-base leading-5 font-medium sm:text-xl',
        className,
      )}
      {...props}
    >
      <span className="profile-name">{name}</span>
      {', '}
      {age !== undefined && (
        <Tooltip>
          <TooltipTrigger asChild>
            <span className="profile-age text-cold-400 text-xs font-normal sm:text-base">
              {age}
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <p>Estimated age</p>
          </TooltipContent>
        </Tooltip>
      )}
    </p>
  );
});
